import React from 'react';

import logo from '../../assets/gfk_logo.svg';

type Props = {
  mini?: boolean;
};
function Logo({ mini = false }: Props): JSX.Element {
  return (
    <a data-test-id="newron-logo" className="flex items-center gap-x-1 text-lg no-underline" href="/">
      {!mini && (
        <span className="font-bold text-default">
          <span className="text-brand">gfk</span>newron
        </span>
      )}
      <img alt="GfK logo" height="36px" src={logo} />
    </a>
  );
}

export { Logo };
